import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LandingPage } from './pages/LandingPage';
import { BookingPage } from './pages/BookingPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { ImprintPage } from './pages/ImprintPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
export function App() {
  return <HelmetProvider data-id="element-0" data-mp="2mm2nskb9r362">
      <Router data-id="element-1" data-mp="2mmlwdaf14f7f">
        <Routes data-id="element-2" data-mp="2mn5aeg1k6jg6">
          <Route path="/" element={<LandingPage data-id="element-4" data-mp="2mjzp7bw1w1pq" />} data-id="element-3" data-mp="2mnng03a42a0r" />
          <Route path="/Kostenloses-Strategiegespraech" element={<BookingPage data-id="element-6" data-mp="2wk06ksad07ra" />} data-id="element-5" data-mp="31b8fzobovt4g" />
          <Route path="/impressum" element={<ImpressumPage data-id="element-8" data-mp="2whx8rm2ytac0" />} data-id="element-7" data-mp="2wiyuqllirh8i" />
          <Route path="/datenschutz" element={<DatenschutzPage data-id="element-10" data-mp="28t4m6g88geu2" />} data-id="element-9" data-mp="28u5zkrcq1dey" />
          <Route path="/en/imprint" element={<ImprintPage data-id="element-12" data-mp="23vkzcrxgytqi" />} data-id="element-11" data-mp="28sb9yzqi8x4j" />
          <Route path="/en/privacy-policy" element={<PrivacyPolicyPage data-id="element-14" data-mp="23ti8k5ohswkq" />} data-id="element-13" data-mp="23u9qidp62vsj" />
        </Routes>
      </Router>
    </HelmetProvider>;
}